import { axiosMockAdapterInstance } from "apis/index";
import { getResponseData } from "./index";

export const data = {
  statusCode: 200,
  time: "2022-06-02T09:14:49.838Z",
  records: [
    {
      blockTimestamp: "2022-06-13T07:47:25.000Z",
      hash: "0x114f175d010182da1b6952b8f7bf704b816e36f39e16ef95d8adf8b1d2760f6c",
      tokenType: "CRYPTO",
      from: "0x8809e73c770f8660fc2e6b2e58112d88d6806d01",
      to: "0xe67c79d3e634156d30cc6910579939344d1b1beb",
      tokenGas: {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
      },
      gasFee: 0.00051905,
      token: {
        name: "TRON",
        slug: "TRON",
        network: "binance-smart-chain-testnet",
      },
      amount: "1000",
      action: "withdraw",
    },
  ],
  total: 1,
};

export const onGetTrans = (query) => {
  let { page, limit, action, to, from, hash } = query;
  let dataQuery = data.records;
  let total = data.total;
  if (action) {
    dataQuery = data.records.filter((x) => x.action === action);
    total = dataQuery.length;
  }
  if (to) {
    dataQuery = data.records.filter((x) => x.to === to);
    total = dataQuery.length;
  }
  if (from) {
    dataQuery = data.records.filter((x) => x.from === from);
    total = dataQuery.length;
  }
  if (hash) {
    dataQuery = data.records.filter((x) => x.hash === hash);
    total = dataQuery.length;
  }
  axiosMockAdapterInstance.onGet("operator-token-transfers").reply(() => {
    let res = dataQuery.filter((x, index) => index < page * limit && index >= (page - 1) * limit);
    let data = {
      records: res,
    };
    return [200, getResponseData(data, total)];
  });
};
